import React from 'react'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import s from './styles/Card.module.scss'

const Card = ({
	title,
	subtitle,
	author,
	date,
	selected,
	onSelect,
	isLoading = false,
}) => (
	<button
		type="button"
		className={`${s.card} ${selected ? s.active : ''} ${isLoading ? s.loading : ''}`}
		onClick={isLoading ? undefined : onSelect}
		aria-pressed={isLoading ? undefined : selected}
		disabled={isLoading}
	>
		{isLoading ? (
			<LoaderImg />
		) : (
			<>
				<span className={s.icon}>
					<DockIcon />
				</span>
				<span className={s.inner}>
					<span className={s.title}>{title}</span>
					<span className={s.subtitle}>{subtitle}</span>
					<span className={s.date}>
						{author ? `By ${author}` : null}
						{author && date ? ' · ' : null}
						{date}
					</span>
				</span>
				<span className={s.radio}>
					<span className={s.radio__dot} />
				</span>
			</>
		)}
	</button>
)

export default Card
